import { i18n } from 'common/hooks/useI18n/useI18n.hook';

export type ModalState = {
  isModalOpen: boolean;
  contextModal: {
    component?: React.ReactNode;
    hideCloseIcon?: boolean;
    wrapperClassName?: string;
    backdropClassName?: string;
    closeOnClickOutside?: boolean;
    onCloseHandler?: () => void;
    title?: React.ReactNode | ((translate: i18n['translateToText']) => React.ReactNode);
    description?: string;
    useBottomSheet?: boolean;
    animation?: 'slideLeft' | 'slideRight' | 'appearUp';
    onResolve?: () => void;
    onReject?: () => void;
  };
};

export type ModalAction = ModalState['contextModal'];

export const modalInitialState: ModalState = {
  isModalOpen: false,
  contextModal: {
    closeOnClickOutside: true,
  },
};
